import styled from "@emotion/styled";

const OpenCallCardGrid = styled.div(({ theme }) => ({
  display: "grid",
  gap: theme.spacing.gap,
  [theme.breakpoints.xs]: {
    gridTemplateColumns: `repeat(2, calc(50% - (${theme.spacing.gap} * .5)))`,
  },
  [theme.breakpoints.desktop]: {
    gridTemplateColumns: `repeat(3, calc((100% / 3) - (${theme.spacing.gap} * .667)))`,
  },
  [theme.breakpoints.desktopLarge]: {
    gridTemplateColumns: `repeat(4, calc((100% / 4) - (${theme.spacing.gap} * .75)))`,
  },
}));

export { OpenCallCardGrid };
